// ============================================================================
// APPLICATION SERVICE
// ============================================================================
// Business logic and API calls for Application Management module

import { get, post, put, del } from '../client/axiosClient';
import { applicationEndpoints } from '../endpoints';
import type {
  ID,
  ApplicationResponse,
  CreateApplicationRequest,
  UpdateApplicationRequest,
} from '../types';
import type { TenantHubApiResponse } from '../types/auth.types';

/**
 * Application Service Class
 */
class ApplicationService {
  /**
   * Get all applications
   */
  async getAll(): Promise<TenantHubApiResponse<ApplicationResponse[]>> {
    const response = await get<TenantHubApiResponse<ApplicationResponse[]>>(applicationEndpoints.list());
    return response.data;
  }

  /**
   * Get application by ID
   */
  async getById(id: ID): Promise<TenantHubApiResponse<ApplicationResponse>> {
    const response = await get<TenantHubApiResponse<ApplicationResponse>>(applicationEndpoints.getById(id));
    return response.data;
  }

  /**
   * Create new application
   */
  async create(data: CreateApplicationRequest): Promise<TenantHubApiResponse<ApplicationResponse>> {
    const response = await post<TenantHubApiResponse<ApplicationResponse>>(
      applicationEndpoints.create(),
      data
    );
    return response.data;
  }

  /**
   * Update application
   */
  async update(id: ID, data: UpdateApplicationRequest): Promise<TenantHubApiResponse<ApplicationResponse>> {
    const response = await put<TenantHubApiResponse<ApplicationResponse>>(
      applicationEndpoints.update(id),
      data
    );
    return response.data;
  }

  /**
   * Delete application
   */
  async delete(id: ID): Promise<TenantHubApiResponse<boolean>> {
    const response = await del<TenantHubApiResponse<boolean>>(applicationEndpoints.delete(id));
    return response.data;
  }
}

/**
 * Export singleton instance
 */
export const applicationService = new ApplicationService();
export default applicationService;
